import React, { Component } from 'react';
import ElementListTemplate from './ElementListTemplate';
import { connect } from 'react-redux';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as homeActions from '../../../redux/homeActions';
import { bindActionCreators } from 'redux';
import { Label, Input } from 'reactstrap';
import * as Constants from '../../../utilities/constants/Constants';
import { string } from '../../../localization';
import '../SideBarContainer.scss';
import { Icons } from '../../../utilities';
import FolderAuthentication from '../../../components/PopupWindows/FolderAuthentication/FolderAuthentication';
import { isPremiumTheme } from '../../../utilities/HelperFunctions/HelperFunctions';

class ThemeListTemplate extends Component {
  state = { item: null, showAuthenticationWindow: false };

  localAddToCanvas = item => {
    const { addToCanvas } = this.props;
    addToCanvas(item);
  };

  getStyles = dict => {
    if (dict && dict.aspectRatio && dict.aspectRatio >= 1) {
      return 'groupThemeElementWrapper1';
    }
    return 'groupThemeElementWrapper2';
  };

  handleFolderClick = item => {
    const { dispatchers } = this.props;
    this.setState({
      item
    });
    this.authenticationWindowHandler(item.needsAuthenetication);
    if (!item.needsAuthenetication) {
      dispatchers.sideBarActions.getFolderListElements(item);
    }
  };

  authenticationWindowHandler = state => {
    this.setState({ showAuthenticationWindow: state });
  };

  setThemeContainerStyle = item => {
    const { activeTab } = this.props;
    let className = ' ';
    if (activeTab !== Constants.BACKGROUND_TAB_KEY) {
      className = 'col-6 p-0 float-left group-theme-element';
      if (item.name === Constants.THEME.STICKERS) {
        className = [className, 'stickers-bacground'].join(' ');
      }
    }
    return className;
  };

  render() {
    const {
      activeTab,
      data,
      folderListElements,
      tabKey,
      documentColors,
      defaultColors,
      solidBackgroundColor,
      language,
      dispatchers
    } = this.props;

    const { showAuthenticationWindow, item } = this.state;

    let solidColorIndex = -1;
    defaultColors.map((inColor, index) => {
      let color = inColor;
      if (color.substr(0, 1) == '#') color = color.substr(1);
      let uiColor = solidBackgroundColor;
      if (uiColor) {
        if (uiColor.substr(0, 1) == '#') uiColor = uiColor.substr(1);
        if (color === uiColor) {
          solidColorIndex = index;
        }
      }
    });

    let documentColorIndex = -1;
    documentColors.map((inColor, index) => {
      let color = inColor;
      if (color.substr(0, 1) == '#') color = color.substr(1);
      let uiColor = solidBackgroundColor;
      if (uiColor) {
        if (uiColor.substr(0, 1) == '#') uiColor = uiColor.substr(1);
        if (color === uiColor) {
          documentColorIndex = index;
        }
      }
    });

    if (
      (activeTab === Constants.BACKGROUND_TAB_KEY &&
        tabKey === Constants.BACKGROUND_TAB_KEY) ||
      (activeTab === Constants.ELEMENT_TAB_KEY &&
        tabKey === Constants.ELEMENT_TAB_KEY) ||
      (activeTab === Constants.PHOTO_TAB_KEY &&
        tabKey === Constants.PHOTO_TAB_KEY)
    ) {
      if (folderListElements === null) {
        return (
          <div className='d-flex flex-column h-100'>
            {/* <div className="p-4">Flex item 2</div> */}
            {activeTab === Constants.BACKGROUND_TAB_KEY &&
            dispatchers.sideBarActions.isSolidColorSupported() ? (
              <div>
                {/* Document Colors */}
                <div className='text-white '>
                  <div id='textPane'>
                    <span
                      className='d-flex ml-3 mt-3'
                      style={{
                        fontSize: '14px',
                        fontFamily: 'HPSimplifiedLight, Arial, sans-serif'
                      }}
                    >
                      {string.DOCUMENT_COLORS}
                    </span>
                    <div id='textColors' className='text-left pl-3 pt-3 mb-0 '>
                      {documentColors.map((color, index) => (
                        <Label check key={color}>
                          <Input
                            type='radio'
                            name='textColors'
                            value={color}
                            checked={index === documentColorIndex}
                            onClick={() => {
                              dispatchers.sideBarActions.documentColorIsClicked(
                                color
                              );
                            }}
                          />

                          <div
                            className='colorBox'
                            style={{ background: color }}
                          />
                        </Label>
                      ))}
                      <Label check key='plus'>
                        <Input
                          type='radio'
                          onClick={e => {
                            e.stopPropagation();
                            dispatchers.sideBarActions.documentColorPickerIsClicked();
                          }}
                        />
                        <div className='colorBox plus-image' />
                      </Label>
                    </div>
                  </div>
                  <hr
                    className='mt-0 mb-0 '
                    style={{
                      width: '84%',
                      backgroundColor: 'rgb(127, 127, 127)'
                    }}
                  />
                </div>

                {/* Solid colors */}
                <div className='text-white '>
                  <div id='textPane'>
                    <span
                      className='d-flex ml-3 mt-3'
                      style={{
                        fontSize: '14px',
                        fontFamily: 'HPSimplifiedLight, Arial, sans-serif'
                      }}
                    >
                      {string.SOLID_COLORS_KEY}
                    </span>
                    <div id='textColors' className='text-left pl-3 pt-3 mb-0 '>
                      {defaultColors.map((color, index) => (
                        <Label check key={color}>
                          <Input
                            type='radio'
                            name='textColors'
                            value={color}
                            defaultChecked={index === solidColorIndex}
                            onClick={() => {
                              dispatchers.sideBarActions.solidColorIsClicked(
                                color
                              );
                            }}
                          />
                          <div
                            className='colorBox'
                            style={{ background: color }}
                          />
                        </Label>
                      ))}
                    </div>
                  </div>

                  <hr
                    className='mt-0 mb-0 '
                    style={{
                      width: '84%',
                      backgroundColor: 'rgb(127, 127, 127)'
                    }}
                  />
                </div>
              </div>
            ) : null}
            <div className='flex-grow-1 content-box '>
              <div
                className='theme-wrapper theme-wrapper-scroll-bar'
                ref={ref => {
                  this.myRef1 = ref;
                }}
              >
                {data.map((itemData, index) => (
                  <div className='theme-list-box' key={itemData.id}>
                    <div
                      role='button'
                      style={{
                        cursor: 'pointer',
                        position: 'relative',
                        outline: 0
                      }}
                      tabIndex={index}
                      onKeyPress={() => {}}
                      onClick={() => {
                        this.handleFolderClick(itemData);
                      }}
                    >
                      <div className='group-theme-element-container'>
                        {isPremiumTheme(itemData) ||
                        itemData.groupThumbnail.length === 1 ? (
                          <img
                            alt={itemData.groupThumbnail[0].path}
                            className='theme-list-box'
                            src={itemData.groupThumbnail[0].path}
                            style={{ height: '100%', width: '100%' }}
                          />
                        ) : (
                          itemData.groupThumbnail.map(thumbnailDict => (
                            <div
                              className={this.setThemeContainerStyle(itemData)}
                              key={thumbnailDict.path}
                            >
                              {activeTab != Constants.BACKGROUND_TAB_KEY ? (
                                <div className='group-theme-element-wrapper'>
                                  <img
                                    className={
                                      activeTab != Constants.BACKGROUND_TAB_KEY
                                        ? this.getStyles(thumbnailDict)
                                        : null
                                    }
                                    alt={thumbnailDict.path}
                                    src={thumbnailDict.path}
                                    style={{
                                      backgroundSize:
                                        activeTab ===
                                        Constants.BACKGROUND_TAB_KEY
                                          ? 'cover'
                                          : 'contain'
                                    }}
                                  />
                                </div>
                              ) : (
                                <div
                                  key={thumbnailDict}
                                  className='col-6 p-0 float-left group-theme-element'
                                  style={{
                                    backgroundImage: `url(${thumbnailDict.path})`,
                                    backgroundSize:
                                      activeTab === Constants.BACKGROUND_TAB_KEY
                                        ? 'cover'
                                        : 'contain'
                                  }}
                                />
                              )}
                            </div>
                          ))
                        )}
                      </div>
                      {sideBarActions.showPremiumTag(itemData) ? (
                        <div className='premium-folder-tag'>
                          <img src={Icons.premiumBadge} alt='Premium' />
                        </div>
                      ) : null}
                      {itemData.needsAuthenetication ? (
                        <div className='locked-folder'>
                          <img src={Icons.lock} alt='' />
                        </div>
                      ) : null}
                      <div className='hover-layer' />
                      <p className='group-theme-label'>
                        {Object.prototype.hasOwnProperty.call(
                          itemData,
                          'locNames'
                        ) && itemData.locNames
                          ? itemData.locNames[language]
                          : itemData.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {showAuthenticationWindow ? (
              <FolderAuthentication
                item={item}
                isSubtheme={false}
                isOpen={showAuthenticationWindow}
                authenticationWindowHandler={this.authenticationWindowHandler}
              />
            ) : null}
          </div>
        );
      }
      return <ElementListTemplate />;
    }
    return null;
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    data: state.modal[state.sideBar.activeSideBarTab],
    folderListElements: state.sideBar.folderListElements,
    loadMoreContents: state.sideBar.loadMoreContents,
    documentColors: state.sideBar.documentColors,
    defaultColors: state.modal.defaultColors,
    envData: state.modal.envData,
    language: state.home.language,
    solidBackgroundColor: state.sideBar.solidBackgroundColor
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      homeActions: bindActionCreators(homeActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeListTemplate);
